import { render, staticRenderFns } from "./ViewCandidateProfile.vue?vue&type=template&id=7a96ea57&"
import script from "./ViewCandidateProfile.vue?vue&type=script&lang=js&"
export * from "./ViewCandidateProfile.vue?vue&type=script&lang=js&"
import style0 from "./ViewCandidateProfile.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports